export const DRGBL_PAGE = 'PAGE';
export const DRGBL_PAGE_GROUP = 'PAGE_GROUP';
export const DRGBL_TIMELINE = 'TIMELINE';
